
import AxiosClient from "../../../services/axios.services";

class FormEvalFactorServices {
  getFormEvalFactors = params =>
    AxiosClient.get("api/app/evaluacion_despliegue_preguntas_factor/", {
      headers: { "Content-Type": "application/json" },
      params: params,
   });
  getFormEvalFactor = id =>
    AxiosClient.get(`api/app/evaluacion_despliegue_preguntas_factor/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveFormEvalFactor = data =>
    AxiosClient.post("api/app/evaluacion_despliegue_preguntas_factor/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editFormEvalFactor = (id, data) =>
    AxiosClient.put(
      `api/app/evaluacion_despliegue_preguntas_factor/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  deleteFormEvalFactor = id =>
    AxiosClient.delete(`api/app/evaluacion_despliegue_preguntas_factor/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new FormEvalFactorServices();

